import { Component } from "react"

/* Router */
import { Link } from "react-router-dom"

/* Components */
import Icon from "./Icon"

/* Helpers */
import { withRouter } from "../helpers"

/* JWT */
import { decodeToken } from "react-jwt"


/* Component Header — the account of the administrator in the right corner of every page */
class Header extends Component {

    constructor() {
        super()

        this.state = {
            visible: false
        }
    }

    componentDidMount = () => {
        document.addEventListener("click", this.handleClickOutside, true)
    }

    componentWillUnmount = () => {
        document.removeEventListener("click", this.handleClickOutside, true)
    }

    /* Click Outside Handler */
    handleClickOutside = event => {

        if (this._menu && !this._menu.contains(event.target) && this._user && !this._user.contains(event.target)) {
            this.setState({ visible: false })
        }
    }

    /* Logout action */
    logout = () => {

        const { setToken, navigate } = this.props

        localStorage.removeItem("token")
        setToken(null)
        navigate("/")
    }

    render = () => {

        /* Fields */
        const { visible } = this.state
        const { token } = this.props

        const user = decodeToken(token)

        /* Check Data */
        if (user === null || user === undefined) {
            return null
        }

        const name = user.name ? user.name : "Администратор"

        return (
            <div className="header">

                <div ref={ref => this._user = ref} onClick={() => this.setState({ visible: !visible })} className={`header-user ${visible ? "active" : ""}`}>

                    <div className="header-avatar">
                        <Icon name="user" size={19} />
                    </div>

                    <div className="header-user-text">
                        <div className="header-user-name">{name}</div>
                        <div className="header-user-role">Администратор</div>
                    </div>

                    <div className={`header-chevron ${visible ? "open" : ""}`}>
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                            <path d="M2.5 4.5L6 8L9.5 4.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>

                </div>

                <div ref={ref => this._menu = ref} className={`header-menu ${visible ? "active" : ""}`}>

                    <div className="header-menu-info">
                        <div className="header-menu-avatar">
                            <Icon name="user" size={20} />
                        </div>
                        <div className="header-menu-info-text">
                            <div className="header-menu-info-name">{name}</div>
                            <div className="header-menu-info-role">{user.email ? user.email : "Администратор"}</div>
                        </div>
                    </div>

                    <div className="header-menu-divider" />

                    <Link onClick={() => this.setState({ visible: false })} to="/profile" className="header-menu-item">
                        <Icon name="profile" size={18} />
                        <span>Профиль</span>
                    </Link>

                    <Link onClick={() => this.setState({ visible: false })} to="/change-password" className="header-menu-item">
                        <Icon name="password" size={18} />
                        <span>Изменить пароль</span>
                    </Link>

                    <div className="header-menu-divider" />

                    <div onClick={() => this.logout()} className="header-menu-item logout">
                        <Icon name="logout" size={18} />
                        <span>Выйти</span>
                    </div>

                </div>

            </div>
        )
    }
}

export default withRouter(Header)
